/**
 * The structural signature from DESIGN_GUIDELINES.md §7.2: a full-bleed green canvas with a
 * single inset white card. The card always keeps visible green margin on every side, at every
 * breakpoint — a card that touches the viewport edge loses the brand.
 */

import type { ReactNode } from 'react';

export function AppCanvas({ children }: { children: ReactNode }) {
  return (
    <div className="ff-canvas">
      <div className="ff-card">{children}</div>
    </div>
  );
}
